
import React, { Component, Fragment, useEffect, useState, useContext } from "react";
import { SessionContext } from "../../../context/SessionProvider";

import authService from '../../api-authorization/AuthorizeService'
import useFetch from "../../helpers/useFetch";
import BiButton from "../../uic/controls/BiButton";
import BiLabel from "../../uic/controls/BiLabel";
import BiDataGrid from "../../uic/dataGrid/BiDataGrid"
import { useNavigate } from 'react-router-dom';

const CertifikatiStranka = (props) => {
    const navigate = useNavigate();

    const { sessionReady, setLoading, toastError, toastOK, setHelpMainKey } = useContext(SessionContext)
    const { data: certs,setUrl: setCertsURL, isLoaded } = useFetch(null);
    useEffect(() => { setLoading(false); }, [isLoaded]);

    useEffect(() => {
        if (sessionReady) {
            setLoading(true);
            setCertsURL('api/certifikati/GetCertifikatiStranka');
        }
    }, [sessionReady])
    const [izbranCert, setIzbranCert] = useState(null);

   
    const gumbIzpolni = (col, item) => {
        return <BiButton icon="fas fa-download " onClick={()=>odpriCert(item)} >Prenesi</BiButton>
    }

    const odpriCert = (cert) => {
       
        const sss = authService.getAccessToken().then(token => {

            const requestOptions = {
                method: 'GET',
                responseType: 'blob',
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            };

            const params = {
                report: "rptCertifikat",
                param1: "'" + cert.idGuid + "'",
                marginLeft: "0.1",
                marginRight: "0"
            };
            const url = "api/report/GetReport" + "?" + (new URLSearchParams(params)).toString();
            fetch(url, requestOptions)
                .then(response => {
                    return response.blob();
                }).then(ret => {

                    const file = new Blob([ret], { type: "application/pdf" });
                    const fileURL = URL.createObjectURL(file);

                    var anchor = document.createElement("a");
                    anchor.download = cert.idGuid +".pdf";
                    anchor.href = fileURL;
                    anchor.click();


                });
        });

    }

    console.log(props)
    return (

        <Fragment >
            {certs && 
                <Fragment>

                    <h2 id="tabelLabel" >Seznam vseh certifikatov</h2>
                    <p>Na seznamu so vsi certifikati za tekoče leto.</p>

                    <BiDataGrid
                        items={certs}
                        mainKey="pIdCertifikat"
                        onSelectionChanged={(d) => setIzbranCert(d.pIdCertifikat)}
                        columns={[
                            { label: "ID", key: "pIdCertifikat", type: "decimal", width: "50px" },
                            { label: "Opis", key: "tipKontrole", type: "string", width: "200px" },
                            { label: "Datum", key: "datumCertificiranja", type: "date", width: "150px" },
                            { label: "", key: "pIdStatus", type: "template", displayFunction: gumbIzpolni, width: "130px", cellStyle: { style: { padding: "0px" } } },
                            { width: "100%" },
                        ]}

                    ></BiDataGrid>

                </Fragment>
            
            }
        </Fragment>   
    );

}

export default CertifikatiStranka;